'use client'

import Link from 'next/link'
import React from 'react'

import { useAccordion } from '@/_hooks/useAccordion'
import { useSectionParams } from '@/_i18n/section-params'
import { getIcon } from '@/_lib/iconsMap.const'
import { formatPrice, handleProgramaticScroll } from '@/_lib/utils'
import { IPreventiveExaminationReduced } from '@/_types'

interface IProps {
	preventiveExaminations: IPreventiveExaminationReduced[]
}

// TODO: Preklady

const APPAccordion = ({ preventiveExaminations }: IProps) => {
	const { toggleAccordion, expandedClass } = useAccordion({ initialExpanded: true })
	const { getSectionParams } = useSectionParams('preventiveExaminations')

	const handleScrollToProgram = (
		preventiveExaminationId: number,
		e: React.MouseEvent<HTMLAnchorElement>
	) => {
		if (typeof window === 'undefined') return
		handleProgramaticScroll(e)
		const targetPreventiveExaminationCard = document.querySelector(
			`#${getSectionParams('preventiveExaminationDetail')}-${preventiveExaminationId}`
		) as HTMLDivElement

		const accordionItem = targetPreventiveExaminationCard?.querySelector(
			'.item_complex-health_text'
		) as HTMLElement

		const isOpened = accordionItem?.classList.contains('expanded')

		if (!isOpened) {
			const expandButton = targetPreventiveExaminationCard?.querySelector(
				'a[title="Viac informácií o balíku"]'
			) as HTMLAnchorElement

			if (expandButton) {
				expandButton.click()
			}
		}
	}

	return (
		<div className='accord mgt-65 mgt-40lg'>
			{preventiveExaminations
				.sort((a, b) => b.price - a.price)
				.map(preventiveExamination => (
					<div
						key={preventiveExamination.id}
						className={`item_accord accorditem ${expandedClass(
							preventiveExamination.id?.toString()
						)}`}
					>
						<a
							href='#'
							title=''
							className={`item_accord_head accordhead`}
							onClick={toggleAccordion(preventiveExamination.id?.toString())}
						>
							<span>{preventiveExamination.name}</span>
							<div className='icons flex'>
								{preventiveExamination.benefits
									.sort((a, b) => a.sortOrder - b.sortOrder)
									.map(benefit =>
										getIcon(benefit.icon) ? (
											<img
												key={benefit.id}
												src={getIcon(benefit.icon) as string}
												alt={benefit.name}
											/>
										) : (
											<div key={benefit.icon} />
										)
									)}
							</div>
							<svg className='sico'>
								<use href='/assets/layout/icons.svg#s_ar1_d' />
							</svg>
						</a>
						<div className='item_accord_expand'>
							<div>
								<div className='item_accord_content'>
									<div className='page_content reset_margins'>
										<p>{preventiveExamination.description}</p>
										<div className='dflex flex-wrap'>
											<div className='w100p dflex justify-between align-center mgt-20lg mgt-30 detail-offer'>
												<Link
													href={`#${getSectionParams(
														'preventiveExaminationDetail'
													)}-${preventiveExamination.id}`}
													title='Detail programu'
													className='btn_basic type5-small'
													prefetch={false}
													onClick={e =>
														handleScrollToProgram(
															preventiveExamination.id,
															e
														)
													}
												>
													<span>Detail programu</span>
													<span>
														<span>
															<svg className='sico'>
																<use href='/assets/layout/icons.svg#s_ar1_d' />
															</svg>
														</span>
														<span>
															<svg className='sico'>
																<use href='/assets/layout/icons.svg#s_ar1_d' />
															</svg>
														</span>
													</span>
												</Link>
												<div className='hide_mdm'>
													<span>
														<strong>
															Cena:{' '}
															{
																formatPrice(
																	preventiveExamination.price
																).price
															}
															{
																formatPrice(
																	preventiveExamination.price
																).currency
															}
														</strong>
													</span>
												</div>
											</div>
											<div className='w100p dflex justify-between align-center mgt-10'>
												<Link
													href={`#${getSectionParams(
														'preventiveExaminationProgramsComparison'
													)}`}
													title='Porovnanie programov'
													className='btn_basic type5-small'
													prefetch={false}
													onClick={e => handleProgramaticScroll(e)}
												>
													<span>Porovnanie programov</span>
													<span>
														<span>
															<svg className='sico'>
																<use href='/assets/layout/icons.svg#s_ar1_d' />
															</svg>
														</span>
														<span>
															<svg className='sico'>
																<use href='/assets/layout/icons.svg#s_ar1_d' />
															</svg>
														</span>
													</span>
												</Link>
												<Link
													href={`/volne-terminy?type=preventive-examination&id=${preventiveExamination.id}`}
													title='Objednajte sa'
													className='btn_basic type4 hide_lgm'
													prefetch={false}
												>
													<span>Objednať</span>
													<span>
														<span>
															<svg className='sico'>
																<use href='/assets/layout/icons.svg#s_ar2_r' />
															</svg>
														</span>
														<span>
															<svg className='sico'>
																<use href='/assets/layout/icons.svg#s_ar2_r' />
															</svg>
														</span>
													</span>
												</Link>
											</div>
											<div className='w100p dflex hide_md mgt-20'>
												<span>
													<strong>
														Cena: {preventiveExamination.price}
													</strong>
												</span>
											</div>
											<div className='w100p dflex justify-center hide_lg mgt-20 mgb-20'>
												<Link
													href={`/volne-terminy?type=preventive-examination&id=${preventiveExamination.id}`}
													title='Objednať program'
													className='btn_basic type4'
													prefetch={false}
												>
													<span>Objednať program</span>
													<span>
														<span>
															<svg className='sico'>
																<use href='/assets/layout/icons.svg#s_ar2_r' />
															</svg>
														</span>
														<span>
															<svg className='sico'>
																<use href='/assets/layout/icons.svg#s_ar2_r' />
															</svg>
														</span>
													</span>
												</Link>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				))}
		</div>
	)
}

export default APPAccordion
